<template>

  <div class="corretiva-defeito ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->


              <b-col cols="1">
                <br>
                <b-button variant="warning" class="ml-5 mt-2" v-b-modal.modal-multi-defeito @click="reset()">Novo</b-button>
              </b-col>

          </b-row>
    </b-form>

    
    <div class="d-flex justify-content-center mb-3">      
    </div>    
    <!--tbl de dados -->
    <b-table id="defeito"  small hover striped sticky-header="550px"  :items="defeitos" :fields="fields" >    
        <template slot="cell(actions)" slot-scope="data"  >
          <b-button  @click="editDefeito(data.item)"    title="Editar Defeito"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.modal-multi-defeito>                
            <i class="fa fa-exclamation-circle"></i>              
          </b-button> 
        </template>   
    </b-table>

      <!--  MODAL GRAVAÇÃO RELACAO DA DEFEITO CORRETIVA -->
      <!--  MODAL GRAVAÇÃO RELACAO DA DEFEITO CORRETIVA -->
      <div>        
    <b-modal id="modal-multi-defeito"   hide-footer size="lg" title="Cadastro de defeitos">
          <!-- -->
          <div>
            <b-row>
              <b-col cols="6">
                <label for="input-grupo">Grupo</label>  -- {{defeito.id_grupo}}
                <div>                
                  <b-form-select                  
                    v-model="defeito.id_grupo"                                                     
                    :options="grupos"
                    class="mb-3 "
                    text-field="grupo"
                    @change="loadSubGrupo()"
                    >                
                  </b-form-select>
                </div>
              </b-col> 

              <b-col cols="6">
                <label for="input-grupo">Subgrupo</label>  -- {{defeito.id_subgrupo}}
                <div>                
                  <b-form-select                  
                    v-model="defeito.id_subgrupo"                                                     
                    :options="subgrupos"
                    class="mb-3 "
                    text-field="subgrupo"
                    >                
                  </b-form-select>
                </div>
              </b-col>   
            </b-row>

            <b-row>
              <b-col cols="8">
                <label for="input-live">Defeito</label>
                <b-form-input v-model="defeito.defeito" placeholder="Digite a descrição do defeito"></b-form-input>              
              </b-col> 

                            <b-col cols="2">
                <label for="input-live">Id_cod_Erp</label>
                <b-form-input v-model="defeito.id_defeito_erp" placeholder="Codigo Erp"></b-form-input>              
              </b-col>   
    

              <b-col cols="2">                                              
                  <b-form-checkbox
                    id="APP-terminal" 
                    class="mb-3 mt-5"
                    v-model="defeito.ponto"                  
                    name="checkbox-2"
                    value="true"
                    unchecked-value="false"
                    checked="true"
                  >                  
                  APP-ponto 
                  </b-form-checkbox>                
              </b-col>



          </b-row>  
          <input  id="id-defeito" type="hidden" v-model="defeitos.id_defeito" />
         
             <b-button class="mt-3" variant="success" block @click="postDefeito()">Gravar</b-button>            
          </div>          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA DEFEITO INDISPONIVEL -->
  </div>  
</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
//import Multiselect from 'vue-multiselect'
import moment from 'moment'




export default {    
    name: 'ManutencaoSUBgrupo',    

    data: function() {

        
      
        return {                        
            carregando: false,            
            grupos:[],                                
            subgrupos: [],   // [] lista   
            defeitos:[],
            defeito:{},
            
            
          //  barra_inicial: 0,         
          //  barra_limite: 300000,
            
            fields: [

                { key: 'id_defeito', label: 'Id_defeito', sortable: true },     
                { key: 'defeito', label: 'Defeito', sortable: true },                                                        

                { key: 'id_subgrupo', label: 'Id_subgrupo', sortable: true },     
                { key: 'subgrupo', label: 'SubGrupo', sortable: true },                                         
                
                { key: 'id_grupo', label: 'Id_grupo', sortable: true },     
                { key: 'grupo', label: 'Grupo', sortable: true },   
                
                { key: 'dt_cadastro', label: 'Data Cadastro', sortable: true, formatter: (value, key, defeitos) => {
                    return moment(defeitos.dt_cadastro).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                { key: 'dt_alteracao', label: 'Data Alteracao', sortable: true, formatter: (value, key, defeitos) => {
                    return moment(defeitos.dt_alteracao).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                { key: 'id_defeito_erp', label: 'Código JB', sortable: true },   


                { key: 'ponto', label: 'Exibe no APP-PONTO', sortable: true,
                    formatter: value => value ? 'Sim' : 'Não' },

                { key: 'actions', label: 'Ações' },
                
            ]
        }        
    },

    components: {
        
    },
    methods: {

      loadGrupo() {          
          const url = `${baseApiUrl}/manutencao/corretiva/grupo`
          axios.get(url).then(res => {
            this.grupos = res.data.map(gru => {              
              return { ... gru, value: gru.id_grupo, grupo: gru.grupo  }
            })
          })
        },
        
        loadSubGrupo() { 
            let corpo = {    
                "id_grupo"    : `${[this.defeito.id_grupo]}`     
            };         
          const url = `${baseApiUrl}/manutencao/corretiva/defeito/subgrupo`
          axios.post(url,corpo).then(res => {
            this.subgrupos = res.data.map(sgru => {              
              return { ... sgru, value: sgru.id_subgrupo, subgrupo: sgru.subgrupo  }
            })
          })
        },  

        loadDefeito() {          
          const url = `${baseApiUrl}/manutencao/corretiva/defeito`
          axios.get(url).then(res => {
            this.carregando = false;       
            this.defeitos = res.data.map(defeito => {              
              return { ... defeito}
            })
          })
        },  

        
        editDefeito(defeito){
            this.defeito = { ...defeito }
        },

          
        postDefeito() {                        
        let corpo = {                 
              "id_grupo": `${[this.defeito.id_grupo]}`,     
              "id_subgrupo": `${[this.defeito.id_subgrupo]}`,
              "id_defeito": `${[this.defeito.id_defeito]}`,
              "id_defeito_erp": `${[this.defeito.id_defeito_erp]}`,
              "defeito": `${[this.defeito.defeito]}`,
              "ponto":`${(this.defeito.ponto)?[this.defeito.ponto]:false}`            
        };


        

        const url = `${baseApiUrl}/manutencao/corretiva/defeito`   

            axios.post(url,corpo).then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset() //limpar os objetos valores
                })
                .catch(showError)
        },

        reset() {  
            this.subgrup = {}          
            this.subgrupo = []
            this.defeito = []            
            this.loadDefeito()            
        }
       
    },



    mounted() {  
      this.loadGrupo()
      this.loadSubGrupo()
      this.loadDefeito()
     
    },



}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#selecaostatusx{
    font-size: 0.7em;      
}

#grupos{   
    font-size: 0.9em;      
    text-align: center;
    
}




</style>